module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/account-details/account-details.scss
// module id = ./web/modern/components/settings/profile/account-details/account-details.scss
// module chunks = 0